import { render, staticRenderFns } from "./customerForm.vue?vue&type=template&id=1b4776f3&scoped=true&"
import script from "./customerForm.vue?vue&type=script&lang=js&"
export * from "./customerForm.vue?vue&type=script&lang=js&"
import style0 from "./customerForm.vue?vue&type=style&index=0&id=1b4776f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4776f3",
  null
  
)

export default component.exports